<div class="modal-inner">
    <div class="stepper">
        @if (!data.userId) {
            <div
                [class.active]="activeStep === Step.Type"
                [class.filled]="selection.type"
                (click)="setActiveStep(Step.Type)">
                <small>Type</small>
                {{ selection.type === 'user' ? 'Medewerker' : '' }}
                {{ selection.type === 'entity' ? 'Materieel' : '' }}
                {{ selection.type === 'hiring_user' ? 'Inhuur medewerker' : '' }}
                {{ selection.type === 'hiring_material' ? 'Inhuur materieel' : '' }}
                {{ selection.type === 'planned_users' ? 'Geplande medewerkers' : '' }}
            </div>

            @if (selection.type !== 'planned_users') {
                <div
                    [class.active]="activeStep === Step.Employee"
                    [class.filled]="selection.user_id || selection.entity_id"
                    (click)="setActiveStep(Step.Employee)">
                    <small>{{ selection.type?.slice(-4) === 'user' ? 'Medewerker' : 'Materieel' }}</small>
                    {{ (employees | byId: selection.user_id)?.name }}
                    {{ selection.hiring_name ?? (entities | byId: selection.entity_id)?.name }}
                </div>
            }
        }
        <!-- The colleague route copies hourtypes and times, so these steps do not apply -->
        @if (colleagueTimes === null) {
            <div
                [class.active]="activeStep === Step.Hourtype"
                [class.filled]="selection.hourtype"
                (click)="setActiveStep(Step.Hourtype)">
                <small>Uursoort</small>
                {{ selection.hourtype | hourtype }}
                @if (selection.hourtype === RealisationHourtype.worktime && night) {
                    nacht
                }
            </div>
            <!-- Only show the project step if the caller did not already provide a project/planning to use. -->
            @if (!data.useOnlyProvidedProject) {
                <div
                    [class.active]="activeStep === Step.Project"
                    [class.filled]="activeStep === Step.Vehicle || activeStep === Step.Time"
                    (click)="setActiveStep(Step.Project)">
                    <small>Project</small>
                    {{ selection.afas_project_id ?? '-' }}
                </div>
            }
            <div
                [class.active]="activeStep === Step.Time"
                [class.filled]="selection.time !== null"
                (click)="setActiveStep(Step.Time)">
                <small>Tijd</small>
                @if (selection.time !== null) {
                    <span>
                        <span
                            [class.downlight]="selection.time.begindate | datetimeEquals: previousRealisation?.enddate">
                            {{ selection.time.begindate | date: 'HH:mm' }}
                        </span>
                        -
                        <span [class.downlight]="selection.time.enddate | datetimeEquals: nextRealisation?.begindate">
                            {{ selection.time.enddate | date: 'HH:mm' }}
                        </span>
                    </span>
                }
                @if (selection.time === null) {
                    <span> - </span>
                }
            </div>
            @if (selection.type === 'user') {
                <div [class.active]="activeStep === Step.Vehicle" (click)="setActiveStep(Step.Vehicle)">
                    <small>Voertuig</small>
                </div>
            }
        }
    </div>

    @if (activeStep === Step.Project) {
        <div class="modal-inner-inner">
            <h1>
                Kies een
                @if (onlyOnPlanning) {
                    planning
                } @else {
                    project
                }
            </h1>

            @if (!onlyOnPlanning) {
                <input [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
            }

            <div class="results">
                @if (searching) {
                    <div class="result text-center">aan het zoeken...</div>
                } @else if (!searching && projects?.length === 0) {
                    <div class="result text-center">
                        @if (onlyOnPlanning) {
                            Je bent vandaag niet ingepland en kunt daarom geen uren toevoegen.
                        } @else {
                            {{
                                fcProjectSearch.value?.length > 0
                                    ? 'project niet gevonden'
                                    : 'voer een projectnummer in'
                            }}
                            @if (
                                !([Functionalities.HourCheck, Functionalities.HourCheckRestricted] | hasFunctionality)
                            ) {
                                <br /><br />
                                <i class="fa fa-exclamation-triangle"></i> Zoek op een projectnummer
                            }
                        }
                    </div>
                }
                @for (project of projects; track project; let i = $index) {
                    <div
                        class="result"
                        [class.highlight]="i == selectedIndex"
                        (click)="selectProject(project.projectId, project.planningId)">
                        <strong>{{ project.projectId }}</strong> {{ project.location }}
                    </div>
                }
            </div>
        </div>
    }

    @if (activeStep === Step.Vehicle) {
        <div class="modal-inner-inner">
            <h1>Kies een voertuig ({{ fcEntities.value?.length ?? 0 }} geselecteerd)</h1>
            <input [(ngModel)]="itemSearch" placeholder="Zoeken..." />
            <div class="results">
                <mat-selection-list [formControl]="fcEntities">
                    @for (entity of entities; track entity) {
                        <mat-list-option
                            [value]="entity.id"
                            [class.d-none]="
                                itemSearch?.length > 0 &&
                                entity.name.toLowerCase().indexOf(itemSearch.toLowerCase()) === -1
                            ">
                            {{ entity.name }}
                        </mat-list-option>
                    }
                </mat-selection-list>
            </div>
        </div>
    }

    @if (activeStep === Step.Type) {
        <div class="modal-inner-inner">
            <h1>Kies een type</h1>
            <div class="results">
                <div class="choose-buttons mb-2">
                    <button class="planning-button cancel" (click)="setType('entity')" mat-raised-button>
                        <i class="fa-duotone fa-truck fa-2x"></i><br />
                        Materieel
                    </button>
                    <button class="planning-button cancel" (click)="setType('user')" mat-raised-button>
                        <i class="fa-duotone fa-user fa-2x"></i><br />
                        Medewerker
                    </button>
                </div>
                <div class="choose-buttons mb-3">
                    <button class="planning-button cancel" (click)="setType('hiring_material')" mat-raised-button>
                        <i class="fa-thin fa-truck fa-2x"></i><br />
                        Inhuur materieel
                    </button>
                    <button class="planning-button cancel" (click)="setType('hiring_user')" mat-raised-button>
                        <i class="fa-thin fa-user fa-2x"></i><br />
                        Inhuur medewerker
                    </button>
                </div>
                @if (data.plannedUserIds?.length) {
                    <div class="choose-buttons mb-3">
                        <button class="planning-button cancel" (click)="setType('planned_users')" mat-raised-button>
                            <i class="fa-duotone fa-users fa-2x"></i><br />
                            Geplande medewerkers
                        </button>
                    </div>
                }
            </div>
        </div>
    }

    @if (activeStep === Step.Hourtype) {
        <div class="modal-inner-inner">
            <h1>Kies een uursoort</h1>
            @if (otherRealisationsThisDay?.realisations?.length) {
                <div class="other-hours-day">
                    <div>
                        {{ (employees | byId: selection.user_id)?.name }} heeft
                        @if (data.bookdate | isToday) {
                            vandaag
                        } @else if (!(data.bookdate | isToday)) {
                            op {{ data.bookdate | date: 'EEEE d MMMM' }}
                        }
                        al urenregistraties:
                    </div>

                    @if (otherRealisationsThisDay?.realisations) {
                        @for (realisation of otherRealisationsThisDay.realisations; track realisation) {
                            <div>
                                - {{ realisation.begindate | date: 'EEE HH:mm' }}--
                                {{ realisation.enddate | date: 'HH:mm' }}
                                -
                                {{
                                    realisation.planning?.afas_project_id ??
                                        realisation.afas_project_id ??
                                        realisation?.user_planning?.project?.afas_project_id
                                }}
                                @if (realisation.hourtype === RealisationHourtype.sleep) {
                                    Slaapdag
                                }
                                -
                                @if (!realisation?.planning_has?.performer?.name) {
                                    @if (otherRealisationsThisDay.showProjectTeamPerformer) {
                                        {{
                                            realisation?.planning?.performer_user?.name ??
                                                realisation?.project?.performer?.name ??
                                                realisation?.user_planning?.project?.performer?.name
                                        }}
                                    }
                                    @if (otherRealisationsThisDay.showAsphaltTeamPerformer) {
                                        @if (
                                            otherRealisationsThisDay.showProjectTeamPerformer &&
                                            (realisation?.planning?.asphalt_performer_user?.name ??
                                                realisation?.project?.asphalt_performer?.name ??
                                                realisation?.user_planning?.project?.asphalt_performer?.name)
                                        ) {
                                            /
                                        }
                                        {{
                                            realisation?.planning?.asphalt_performer_user?.name ??
                                                realisation?.project?.asphalt_performer?.name ??
                                                realisation?.user_planning?.project?.asphalt_performer?.name
                                        }}
                                        @if (
                                            !(
                                                realisation?.planning?.asphalt_performer_user?.name ??
                                                realisation?.project?.asphalt_performer?.name ??
                                                realisation?.user_planning?.project?.asphalt_performer?.name
                                            )
                                        ) {
                                            {{
                                                realisation?.planning?.performer_user?.name ??
                                                    realisation?.project?.performer?.name ??
                                                    realisation?.user_planning?.project?.performer?.name
                                            }}
                                        }
                                    }
                                }
                                @if (realisation?.planning_has?.performer?.name) {
                                    {{ realisation?.planning_has?.performer?.name }}
                                }
                            </div>
                        }
                    }
                    <div class="mt-1">Je kunt extra uren toevoegen.</div>
                </div>
            }
            <div class="results">
                @if (selection.user_id || selection.type === 'planned_users') {
                    <div class="choose-buttons mb-3">
                        @for (hourtype of environment.realisationHourTypes; track hourtype) {
                            <button class="planning-button cancel" (click)="setHourtype(hourtype)" mat-raised-button>
                                <i class="fa-duotone {{ hourtype | hourtypeIcon }} fa-2x"></i><br />
                                {{ hourtype | hourtype }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (activeStep === Step.Time) {
        <div class="modal-inner-inner">
            <h1>Kies een tijd</h1>
            <div class="results">
                @if (currentMinutes > 0) {
                    <h2>
                        Uren vandaag: {{ currentMinutes - currentPause | minutes }} uur +
                        <i class="fas fa-mug-saucer"></i> {{ currentPause | minutes }}
                    </h2>
                }
                @if (currentMinutes > 0) {
                    <h2>
                        Gewerkte tijden:
                        {{ nextRealisation?.begindate | date: 'EEE HH:mm' }} -
                        {{ previousRealisation?.enddate | date: 'EEE HH:mm' }}
                    </h2>
                }
                @if (currentMinutes == 0 && selection.type !== 'planned_users') {
                    <h2>Nog geen uren geregistreerd</h2>
                }
                <div class="choose-buttons two mb-3">
                    @for (timeOption of timeOptions; track trackTimeOption(timeOption)) {
                        <ng-container *ngTemplateOutlet="timeButton; context: { $implicit: timeOption }"></ng-container>
                    }
                </div>
                @let existingOptions = existingTimeOptions;
                @if (existingOptions.length) {
                    <h2>Bestaande registraties</h2>
                    <div class="choose-buttons two mb-3">
                        @for (timeOption of existingOptions; track trackTimeOption(timeOption)) {
                            <ng-container
                                *ngTemplateOutlet="timeButton; context: { $implicit: timeOption }"></ng-container>
                        }
                    </div>
                }
                <ng-template #timeButton let-timeOption>
                    <button class="planning-button cancel" (click)="setTime(timeOption)" mat-raised-button>
                        <i class="fa-duotone {{ selection.hourtype | hourtypeIcon }} fa-2x"></i><br />
                        <span [class.downlight]="timeOption.begindate | datetimeEquals: previousRealisation?.enddate">
                            {{ timeOption.begindate | date: 'EEE HH:mm' }}
                        </span>
                        -
                        <span [class.downlight]="timeOption.enddate | datetimeEquals: nextRealisation?.begindate">
                            {{ timeOption.enddate | date: 'EEE HH:mm' }}
                        </span>
                    </button>
                </ng-template>
            </div>
        </div>
    }

    @if (activeStep === Step.Employee) {
        <div class="modal-inner-inner">
            <h1>
                Kies {{ selection.type === 'user' || selection.type === 'hiring_user' ? 'medewerker' : 'materieel' }}
            </h1>
            <input [formControl]="fcItemSearch" placeholder="Zoeken..." />
            @if (selection.type === 'user') {
                <div class="results">
                    @for (user of employees | search: 'name' : fcItemSearch.value; track user; let i = $index) {
                        <div class="result" [class.highlight]="selectedIndex === i" (click)="setUser(user.id)">
                            <strong>{{ user.name }}</strong> {{ user.function }}
                        </div>
                    }
                </div>
            }
            @if (selection.type === 'entity') {
                <div class="results">
                    @for (entity of entities | search: 'name' : fcItemSearch.value; track entity) {
                        <div class="result" (click)="setEntity(entity)">
                            <strong>{{ entity.name }}</strong>
                        </div>
                    }
                </div>
            }
            @if (selection.type === 'hiring_material' || selection.type === 'hiring_user') {
                <div class="results">
                    @if (fcItemSearch.value?.length > 2) {
                        <div class="result" (click)="setHiring(fcItemSearch.value)">
                            <strong>{{ fcItemSearch.value }}</strong>
                        </div>
                    }
                    @for (entity of hirings; track entity) {
                        <div class="result" (click)="setHiring(entity)">
                            <strong>{{ entity }}</strong>
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (activeStep === Step.Confirm) {
        <div class="modal-inner-inner">
            <h1>Overzicht</h1>
            <div class="results">
                @for (times of colleagueTimes; track times) {
                    <div class="result">
                        <i class="fa-duotone {{ times.hourtype | hourtypeIcon }}"></i>
                        <strong>{{ times.hourtype | hourtype }}</strong>
                        {{ times.begindate | date: 'EEE HH:mm' }} - {{ times.enddate | date: 'EEE HH:mm' }}
                    </div>
                } @empty {
                    <div class="result text-center">
                        {{ (employees | byId: selection.user_id)?.name }} is al ingepland
                    </div>
                }
            </div>
        </div>
    }
    <div class="buttons">
        @if (selection.type === 'user' && !(Step.Project === activeStep && optionalProject)) {
            <button
                class="planning-button confirm"
                [disabled]="
                    creating || (activeStep === Step.Confirm ? !colleagueTimes?.length : Step.Vehicle !== activeStep)
                "
                (click)="activeStep === Step.Confirm ? saveColleagueTimes() : createRealisation()"
                mat-raised-button
                color="primary">
                Toevoegen
            </button>
        }

        @if (selection.type === 'user' && Step.Project === activeStep && optionalProject) {
            <button class="planning-button confirm" (click)="selectProject(null)" mat-raised-button color="primary">
                Zonder project
            </button>
        }

        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
